import type { IPAListingMetricMap } from '../types/page-analytic-v2';

import {
  PA_SORT_METRIC_BR,
  PA_SORT_METRIC_CR,
  PA_SORT_METRIC_CTR,
  PA_SORT_METRIC_SESSIONS,
} from './pageAnalytic';
import { ANALYTICS_METRIC_TOOLTIP } from '~/modules/analytics/constants/analytic-metric-tooltip';
import { EMetricKey } from '~/types/metric';

export const LISTING_METRIC_MAP: IPAListingMetricMap = {
  [EMetricKey.SESSION]: {
    label: 'Sessions',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.SESSION],
    sortOptions: PA_SORT_METRIC_SESSIONS,
  },
  [EMetricKey.BOUNCE_RATE]: {
    label: 'Bounce rate',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.BOUNCE_RATE],
    sortOptions: PA_SORT_METRIC_BR,
  },
  [EMetricKey.CTR]: {
    label: 'Click-through rate',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.CTR],
    sortOptions: PA_SORT_METRIC_CTR,
  },
  [EMetricKey.CONVERSION_RATE]: {
    label: 'Conversion rate',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.CONVERSION_RATE],
    sortOptions: PA_SORT_METRIC_CR,
  },
  [EMetricKey.VISITORS]: {
    label: 'Visitors',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.VISITORS],
  },
  [EMetricKey.AVG_TIME_ON_PAGE]: {
    label: 'Avg time on page',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.AVG_TIME_ON_PAGE],
  },
  [EMetricKey.PAGE_VIEWS]: {
    label: 'Pageviews',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.PAGE_VIEWS],
  },
  [EMetricKey.REVENUE]: {
    label: 'Revenue',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.REVENUE],
  },
  [EMetricKey.ADDED_TO_CART]: {
    label: 'Added to cart',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.ADDED_TO_CART],
  },
  [EMetricKey.REACHED_CHECKOUT]: {
    label: 'Sessions that reached checkout',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.REACHED_CHECKOUT],
  },
  [EMetricKey.COMPLETE_CHECKOUT]: {
    label: 'Sessions that completed checkout',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.COMPLETE_CHECKOUT],
  },
  [EMetricKey.RPV]: {
    label: 'Revenue per visitor',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.RPV],
  },
  [EMetricKey.CART_ADDITION]: {
    label: 'Sessions with cart additions',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.CART_ADDITION],
  },
  [EMetricKey.ADD_TO_CART_RATE]: {
    label: 'Add to cart rate',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.ADD_TO_CART_RATE],
  },
  [EMetricKey.ORDERS]: {
    label: 'Orders',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.ORDERS],
  },
  [EMetricKey.AOV]: {
    label: 'Average order value',
    tooltip: ANALYTICS_METRIC_TOOLTIP[EMetricKey.AOV],
  },
};

export const LISTING_METRIC_ORDER: EMetricKey[] = [
  EMetricKey.SESSION,
  EMetricKey.BOUNCE_RATE,
  EMetricKey.CTR,
  EMetricKey.CONVERSION_RATE,
  EMetricKey.VISITORS,
  EMetricKey.AVG_TIME_ON_PAGE,
  EMetricKey.PAGE_VIEWS,
  EMetricKey.REVENUE,
  EMetricKey.ADDED_TO_CART,
  EMetricKey.REACHED_CHECKOUT,
  EMetricKey.COMPLETE_CHECKOUT,
  EMetricKey.RPV,
  EMetricKey.CART_ADDITION,
  EMetricKey.ADD_TO_CART_RATE,
  EMetricKey.ORDERS,
  EMetricKey.AOV,
];

export const LISTING_METRIC_DEFAULT_SELECTION: EMetricKey[] = [
  EMetricKey.SESSION,
  EMetricKey.BOUNCE_RATE,
  EMetricKey.CTR,
  EMetricKey.CONVERSION_RATE,
];
